import React from "react";
import { Loader2, RefreshCw } from "lucide-react";
import { Section, Field, TextField, SelectField } from "./ReviewFields";
import { ALIQUOTE_IVA, NATURA_CODES } from "@/lib/fiscal-constants";

const DOC_TYPES = [
  { code: "TD17", label: "TD17 - Integrazione/autofattura per acquisto servizi dall'estero" },
  { code: "TD18", label: "TD18 - Integrazione per acquisto di beni intracomunitari" },
  { code: "TD19", label: "TD19 - Integrazione/autofattura per acquisto beni ex art.17 c.2 DPR 633/72" },
];

export default function InvoiceDataSection({ extracted, upd, docType, setDocType, refreshFx, refreshingFx }) {
  return (
    <Section title="DATI FATTURA" testid="section-fattura">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Field label="Tipo documento" span={2}>
          <SelectField value={docType} onChange={(e) => setDocType(e.target.value)} testid="doc-type-select">
            {DOC_TYPES.map((d) => (
              <option key={d.code} value={d.code}>
                {d.label}
              </option>
            ))}
          </SelectField>
        </Field>
        <Field
          label="Numero fattura fornitore"
          hint="Numero della fattura originaria del fornitore estero: va come riferimento in Causale. Il numero dell'autofattura (es. AF2026.00001) è progressivo e assegnato in automatico."
        >
          <TextField value={extracted.invoice_number} onChange={upd("invoice_number")} mono testid="field-invoice-number" />
        </Field>
        <Field
          label="Numero autofattura"
          hint="Assegnato automaticamente al primo salvataggio in base al sezionale e al contatore progressivo dell'azienda (es. AF01 1/26). Modificabile solo se strettamente necessario."
        >
          <TextField
            value={extracted.autofattura_number}
            onChange={upd("autofattura_number")}
            mono
            testid="field-autofattura-number"
            placeholder="Verrà assegnato al salvataggio"
          />
        </Field>
        <Field label="Data fattura fornitore" hint="Data della fattura originaria del fornitore (riferimento in Causale).">
          <TextField type="date" value={extracted.invoice_date || ""} onChange={upd("invoice_date")} testid="field-invoice-date" />
        </Field>
        <Field label="Data di ricezione" hint="Data in cui hai ricevuto la fattura estera. Determina la scadenza SDI.">
          <TextField type="date" value={extracted.data_ricezione || ""} onChange={upd("data_ricezione")} testid="field-data-ricezione" />
        </Field>
        <Field label="Data autofattura" hint="Data del documento autofattura (di default = ricezione).">
          <TextField type="date" value={extracted.data_autofattura || ""} onChange={upd("data_autofattura")} testid="field-data-autofattura" />
        </Field>
        <Field label="Divisa">
          <TextField value="EUR" readOnly disabled mono testid="field-currency" className="bg-[#F5F2EA] text-zinc-600 cursor-not-allowed" />
        </Field>
        <Field label="Aliquota IVA (%)">
          <SelectField value={String(extracted.aliquota_iva)} onChange={upd("aliquota_iva")} testid="field-aliquota">
            {ALIQUOTE_IVA.map((a) => (
              <option key={a.value} value={a.value}>
                {a.label}
              </option>
            ))}
          </SelectField>
        </Field>
        <Field label="Natura IVA (opzionale)">
          <SelectField value={extracted.natura || ""} onChange={upd("natura")} testid="field-natura">
            {NATURA_CODES.map((n) => (
              <option key={n.value || "none"} value={n.value}>
                {n.label}
              </option>
            ))}
          </SelectField>
        </Field>
      </div>

      {extracted.original_currency && extracted.original_currency !== "EUR" && (
        <div className="mt-4 rounded-md border border-blue-200 bg-blue-50 p-3 text-xs" data-testid="fx-card">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="font-medium text-blue-900 mb-0.5">Cambio valuta applicato</div>
              <div className="text-blue-800">
                <span className="font-mono">{extracted.original_currency}→EUR</span>
                {" · "}tasso <span className="font-mono">{(extracted.fx_rate || 1).toFixed(4)}</span>
                {" · "}del <span className="font-mono">{extracted.fx_date || "—"}</span>
              </div>
              {extracted.fx_source && (
                <div className="text-blue-700 text-[10px] mt-0.5">Fonte: {extracted.fx_source}</div>
              )}
            </div>
            <button
              type="button"
              onClick={refreshFx}
              disabled={refreshingFx}
              data-testid="refresh-fx-btn"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#1D4ED8] text-white text-xs font-medium hover:bg-[#1E3A8A] disabled:opacity-70 transition-colors whitespace-nowrap"
            >
              {refreshingFx ? <Loader2 className="w-3 h-3 animate-spin" /> : <RefreshCw className="w-3 h-3" />}
              Aggiorna tasso
            </button>
          </div>
        </div>
      )}
    </Section>
  );
}
